<app-choose-game class="slide-out" [ngStyle]="{'display': routeService.previousUrl == '/choose' ? 'block' : 'none'}"
  id="chooseGame"></app-choose-game>
<!-- <app-choose-game class="slide-out" id="chooseGame"></app-choose-game> -->

<div class="page" [ngClass]="{'info-background': gameInfoOpen, 'game-background': !gameInfoOpen}">

  <lottie-player style="position: absolute; z-index: 3;" src="../../assets/anim/BG-match.json" background="transparent"
    speed="1" autoplay>
  </lottie-player>

  <lottie-player *ngIf="gameInfoOpen" style="position: absolute; z-index: 3;" src="../../assets/anim/Moon-match.json"
    background="transparent" speed="0.3" autoplay>
  </lottie-player>

  <lottie-player style="position: absolute; z-index: 3;" src="../../assets/anim/MountBridgeBushesMatch.json"
    background="transparent" speed="0.9" loop autoplay>
  </lottie-player>

  <lottie-player *ngIf="gameInfoOpen" style="position: absolute; z-index: 3;" #trainLottie
    (loop)="finishLoop(trainLottie)" src="../../assets/anim/Train-match.json" background="transparent" speed="0.9" loop
    autoplay>
  </lottie-player>

  <div class="row" *ngIf="didYouKnow && !!currentStation.didYouKnow">
    <!-- <div class="row" *ngIf="true"> -->
    <div class="backdrop go-in" id="backdrop">
      <div #didU class="did-you-know flex-align scale-in-pop">
        <div class="flex-between">
          <img src="./assets/images/icons/verification.png">
          <h1>תשובה נכונה!</h1>
        </div>
        <div style="position: relative; background: rgb(255,255,255,0.7);
        height: 50%;
        box-shadow: 0 0 50px 0px #b2babd;
        width: 75%;
        margin-top: 50px;
        border-radius: 20px;">
          <div>
            <img src="./assets/images/icons/light-bulb.png" class="bulb">
            <h1
              style="color: #f8cd21; direction: ltr;    font-weight: 600; margin: 20px; text-align: center; font-size: 50px;">
              ?הידעת</h1>
          </div>
          <h3 style="color:#004f80;text-align: center;">תחנת {{currentStation.name}}</h3>
          <h4 style="color:#004f80;width: 60%;
          font-weight: 400;
          text-align: center;
          margin: 20px auto;
          line-height: 36px;">{{currentStation.didYouKnow}}</h4>
        </div>
        <div class="match-data-container" style="position: absolute;
        bottom: 26px;
        left: 26px; background-color: #e9eaeb;" (click)="onCloseDidYouKnow(didU)">
          <div class="white-circle">
            <img src="./assets/images/icons/hand.png" class="continue-img">
          </div>
          <h2 class="continue-text">המשך</h2>
        </div>
      </div>
    </div>
  </div>

  <!-- <app-header [game]="game"></app-header> -->
  <app-header></app-header>

  <app-game-info *ngIf="gameInfoOpen" (gameInfoOpen)="closeInfo()" [game]="game"></app-game-info>

  <div id="match-game" *ngIf="!gameInfoOpen">
    <app-game-play [game]="game"></app-game-play>
    <div class="row" *ngIf="mapHelperCounter">
      <div class="backdrop go-in" id="backdrop">
        <div class="map scale-in-pop" id="mapCont">
          <!-- <app-rails-map></app-rails-map> HELPHELP -->
          <img style="width: 100%;
          height: 100%;
          padding: 30px;" src="../../assets/images/backgrounds/rail-full.png">
        </div>
      </div>
    </div>
    <!-- <div class="help-container">
      <div class="flex-align">גלגלי הצלה</div>
      <div class="flex-align">
        <div class="orange-circle">
          <div class="help" id="map" (click)="onHelp('map')" [ngClass]="{used: !mapHelper}">
          </div>
        </div>
        <div class="orange-circle">
          <div class="help" id="color" (click)="onHelp('color')" [ngClass]="{used: !colorHelper}">
          </div>
        </div>
      </div>
    </div> -->
    <div id="game-container">
      <div id="map-container">
        <div class="help-container" *ngIf="gamePlayService.level.getValue() > 2">
          <div class="flex-align">גלגלי הצלה</div>
          <div class="flex-align">
            <div class="orange-circle">
              <div class="help map-help-icon" (click)="onHelp('map')" [ngClass]="{used: !mapHelper}">
              </div>
            </div>
            <div class="orange-circle">
              <div class="help color-help-icon" (click)="onHelp('color')" [ngClass]="{used: !colorHelper}">
              </div>
            </div>
          </div>
        </div>
        <app-rails-map [stations]="currentStations"></app-rails-map>
        <div class="lanes">
          <div class="color-container" *ngFor="let lane of lanes">
            <div class="circle"
              [ngStyle]="{'background-color': lane.color, 'box-shadow': '0px 0px 2px 3px white'}">
            </div>
            <!-- [ngClass]="{lane.color: lane.color, 'box-shadow': '0 0 15px 5px ' + lane.color}" -->
            <h3 [ngStyle]="{'color': 'white'}">{{lane.name}}</h3>
          </div>
        </div>
      </div>
      <div id="station-list">
        <div id="station-title">
          <div class="white-circle">
            <img src="./assets/images/icons/pin.png">
          </div>
          <h3 style="color: white">תחנות</h3>
        </div>
        <div style="overflow: scroll; height: 80%;">
          <!-- [ngClass]="start ? 'station-scale' + i : ''" -->
          <button (click)="nextLvl()">NEXT LEVEL</button>
          <div class="station-container" [ngClass]="{'station-scale': start}" [ngStyle]="{'animation-delay': 0.05*i + 's'}"
            *ngFor="let currentStation of totalStations; let i = index; let first = first" [isLast]="first" (ngInit)="newStations()">
            <div *ngIf="i > 0" class="white-line"></div>
            <div [ngClass]="{'small-white-circle': (i+1)%3 == 0, 'medium-white-circle': (i+1)%3 != 0}">
            </div>
            <!-- draggable="true" (dragstart)="drag($event)" -->
            <!-- (touchmove)="tmove($event)" -->
            <div class="station flex-center" (mousedown)="tpick($event, i)" (mousemove)="tmove($event)"
              (mouseup)="tdrop($event)" (touchstart)="tpick($event, i)" (touchmove)="tmove($event)"
              (touchend)="tdrop($event)" id="{{currentStation.name}}">
              <h5 class="station-name">{{currentStation.name}}</h5>
            </div>
          </div>
        </div>
        <div id="level" class="flip-level">
          <!-- <p id="level-text">שלב {{level}}</p> -->
          <p id="level-text">שלב
            <br>
            {{level}}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
